import type { GetAgencyProfileQuery } from '@sortlist-frontend/data-fetching/public-types';
import { DeepNonNullable } from '@sortlist-frontend/utils';

export type ServiceNode = DeepNonNullable<GetAgencyProfileQuery, 4>['agency']['services']['nodes'][number];
export type ServiceWorkNode = DeepNonNullable<ServiceNode, 3>['works']['nodes'][number];
export type ServiceSkillNode = DeepNonNullable<ServiceNode, 3>['skills']['nodes'][number];
export type ServiceReviewNode = DeepNonNullable<ServiceNode, 3>['reviews']['nodes'][number];

export interface ServiceClient {
  name: string;
  sector: string | null;
  marketSize: string | null;
}

export const extractClientsFromWorks = (works: ServiceNode['works']): ServiceClient[] => {
  const seen = new Set<string>();
  const clients: ServiceClient[] = [];

  for (const work of works.nodes ?? []) {
    if (work?.company?.name != null && !seen.has(work.company.name)) {
      seen.add(work.company.name);
      clients.push({
        name: work.company.name,
        sector: work.company.sector?.name ?? null,
        marketSize: work.company.marketSize ?? null,
      });
    }
  }

  return clients;
};
